export default __webpack_public_path__ + "static/media/pantallagrande1.a7269fe3.png";